export const SET_TOKEN = 'set_token'
export const SET_PHONE = 'set_phone'
export const SET_LOGIN_SOURCE = 'set_login_source'

export const SET_NAV_COLLAPSE = 'set_nav_collapse'

// export const SET_LOGIN_PHONE = 'set_login_phone'
export const SET_COURSES = 'set_courses'
export const SET_COURSE_WRAPPER = 'set_course_wrapper'
export const SET_PAY_INFO = 'set_pay_info'
// export const SET_ORDER = 'set_order'

export const SET_ORDER_CONFIRM_WRAPPER = 'set_order_confirm_wrapper'
export const CLEAR_ORDER_CONFIRM_WRAPPER = 'clear_order_confirm_wrapper'

// export const SET_ID = 'set_id'
// export const SET_MERCHANT_NAME = 'set_merchant_name'
// export const GET_MERCHANT_REGISTER_INFO = 'get_merchant_register_info'

// export const SET_RECREATIONS = 'set_recreations'
// export const CLEAR_RECREATIONS = 'clear_recreations'
// export const SET_NO_MORE_RECREATIONS = 'set_no_more_recreations'
// export const SET_LOADING_RECREATIONS = 'set_loading_recreations'
//
// export const SET_STOREFRONTS = 'set_storefronts'
// export const CLEAR_STOREFRONTS = 'clear_storefronts'
// export const SET_NO_MORE_STOREFRONTS = 'set_no_more_storefronts'
// export const SET_LOADING_STOREFRONTS = 'set_loading_storefronts'
//
// export const SET_COUPONS = 'set_coupons'
// export const CLEAR_COUPONS = 'clear_coupons'
// export const SET_NO_MORE_COUPONS = 'set_no_more_coupons'
// export const SET_LOADING_COUPONS = 'set_loading_coupons'
// export const REMOVE_COUPON = 'remove_coupon'
//
// export const SET_ORDERS = 'set_orders'
// export const CLEAR_ORDERS = 'clear_orders'
//
// export const SET_TRANSACTION_INFOS = 'set_transaction_infos'
// export const CLEAR_TRANSACTION_INFOS = 'clear_transaction_infos'
//
// export const SET_PAGE_SIZE = 'set_page_size'
// export const SET_TOTAL = 'set_total'
// export const SET_LAST_QUERY_INDEX = 'set_last_query_index'
// export const CLEAR_LOGIN_INFO = 'clear_login_info'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js